export default "__VITE_ASSET__BfMQGx_X__"